import { useAtomValue, useSetAtom } from 'jotai';

import { FiltersDrawerRangeSection } from '@common/components/FilterGroups/FiltersDrawerRangeSection';

import { preorderAmountRangeAtom, updatePreorderAmountRangeAtom } from '../../atoms/preordersAtoms';

export function FiltersDrawerPreorderAmountSection(): React.JSX.Element {
	const committedRange = useAtomValue(preorderAmountRangeAtom);
	const setAmountRange = useSetAtom(updatePreorderAmountRangeAtom);

	return (
		<FiltersDrawerRangeSection
			title='Deposit amount'
			description='Filter by deposit amount range'
			value={committedRange}
			onChange={setAmountRange}
		/>
	);
}
